import classNames from 'classnames'
import React from 'react'

import StaticContent from 'components/ui/StaticContent'

const Footer: React.FunctionComponent<Props> = ({ className }) => {
  // @ts-ignore
  const version = window.appversion
  return (
    <div className={classNames('Footer', className)}>
      <StaticContent cache showLoader={false}>
        footer
      </StaticContent>
    </div>
  )
}

Footer.defaultProps = {
  className: '',
}

type Props = {
  className?: string
}

export default Footer
